import { render, staticRenderFns } from "./SalemanBackBindManage.vue?vue&type=template&id=4b4c2742&scoped=true&"
import script from "./SalemanBackBindManage.vue?vue&type=script&lang=js&"
export * from "./SalemanBackBindManage.vue?vue&type=script&lang=js&"
import style0 from "./SalemanBackBindManage.vue?vue&type=style&index=0&id=4b4c2742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4c2742",
  null
  
)

export default component.exports